import { Container } from 'inversify';
import TYPES from './types';

// Infrastructure
import CustomerDocumentsDummyRepository
  from './infrastructure/repositories/customer-documents-dummy-repository/customer-documents-dummy-repository';
import CustomerDocumentsHttpRepository
  from './infrastructure/repositories/customer-documents-http-repository';

// Application
import RequestUpdateCustomerDocumentIneCommand
  from './application/commands/request-update-customer-document-ine-command';

// Domain
import {
  CustomerDocumentsRepository,
} from './domain/repositories/customer-documents-repository';

export default function setupCustomerDocuments(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';

  container
    .bind<CustomerDocumentsRepository>(TYPES.CUSTOMER_DOCUMENTS_REPOSITORY)
    .to(
      withDummies
        ? CustomerDocumentsDummyRepository
        : CustomerDocumentsHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<RequestUpdateCustomerDocumentIneCommand>(TYPES
      .REQUEST_UPDATE_CUSTOMER_DOCUMENT_INE_COMMAND)
    .to(RequestUpdateCustomerDocumentIneCommand)
    .inSingletonScope();
}
